import { ComponentStyleConfig } from '@chakra-ui/react'

export const Modal: ComponentStyleConfig = {
    baseStyle: {
        dialog: {
            bg: 'beige.background',
        },
        header: {
            fontSize: '0.875rem', // heading-xs
            fontWeight: 400, // heading-xs
            lineHeight: '1.4375rem', // heading-xs
            textAlign: 'left',
            textUnderlinePosition: 'from-font',
            textDecorationSkipInk: 'none',
        },
    },
}
